module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "ark_razorbacks_logo.8d626a70.svg";